import styled, { css } from 'styled-components';
import { DropdownMenu } from 'reactstrap';
import { mobileMediaQuery } from '../../utils/responsive';

const fontStyles = css`
  font-size: 13px;
  @media ${mobileMediaQuery} {
    font-size: 1em;
  }
`;

const SmallFontDropdownMenu = styled(DropdownMenu)`
  padding: 4px 0;
  .dropdown-divider {
    margin: 4px 0;
  }
  .dropdown-header,
  .dropdown-item,
  .dropdown-item-text {
    padding: 0.25rem 1rem;
    ${fontStyles}
  }
  ${fontStyles}
`;

export default SmallFontDropdownMenu;
